import React from 'react';
import { useRecoilValue } from 'recoil';
import { isTQAdminState } from '../../store';
import { UnAuthorised } from '../../pages';

export const TQAdminProvider: React.FC = ({ children }) => {
  const isTQAdmin = useRecoilValue(isTQAdminState);
  return isTQAdmin ? <>{children}</> : <UnAuthorised />;
};
